//REGISTER
export const CLINIC_URL = "/clinics"
export const DOCTOR_URL = "/doctors"
export const DOCTOR_TIMING_URL = "/doctor-timings"
export const ROLES_URL = "/roles"
export const PERMISSIONS_URL = "/permissions"
export const USER_URL = "/users"
export const TREATMENT_URL = "/tretments"
export const TREATMENT_TYPE_URL = "/tretments/type"
export const MEDICINE_URL = "/mediciens"
export const BANK_URL = "/banks"
export const BANK_DEPOSIT_URL = "/bank-deposits"
export const ALLERGIES_URL = "/allergies"
export const CHAIR_URL = "/chairs"
export const REFERENCES_URL = "/reference-types"
export const REFERENCE_URL = "/references"
export const PATIENT_URL = "/patients"
export const APPOINTMENT_URL = "/appointment"
export const COMMUNICATION_URL = "/communication-Group"
export const PRESCRIPTION_URL = "/prescriptions"
export const INVESTIONGATIONS_URL = "/investigations"
export const DENTAL_CHART_URL = "/dentalchart"
export const DENTAL_CHART_EXAMINATION_URL = "/dentalcharttoothsexaminations"
export const RX_TEMPLATES_URL = "/rx-templates"
export const EXAMINATIONS_URL = "/examinations"
export const EXAMINATIONS_OPTIONS_URL = "/examination-options"
export const PATIENT_NOTES_URL = "/patient-notes"
export const PATIENT_FOLLOWUP_URL = "/patient-follow-up"
export const NOTIFICATION_URL = "/notifications"
export const NOTIFICATIONS_URL = "/notifications"
export const TASKS_URL = "/notifications/tasks"
export const PATIENT_VIEW_URL = "/patients/view"

// Accounts
export const VOUCHER_URL = '/accounts/voucher'
export const BILLING_URL = '/accounts/billing'
export const PAYMENT_URL = '/accounts/payment'
export const LEDGER_URL = '/accounts/ledger'
export const ACCOUNTS_SUMMARY_URL = '/accounts/summary'
export const ACCOUNTS_PASSBOOK_URL = '/accounts/passbook'

// Files
export const FILES_URL = '/files'

// Tags
export const TAGS_URL = '/tags'
export const LANGUAGES_URL = '/languages'

// AI X-Ray Analysis & Diagnostics
export const XRAY_ANALYSIS_URL = '/xray-analysis'

// Subscriptions & PayU
export const SUBSCRIPTION_URL = '/subscriptions'
